import WgptExecutionsAPI from '../../api/wgpt/taskExecutions';
import types from '../mutation-types';
import { throwErrorMessage } from '../utils/api';

const state = {
  records: [],
  meta: {},
  uiFlags: {
    isFetching: false,
  },
};

export const getters = {
  getExecutions: $state => $state.records,
  getMeta: $state => $state.meta,
  getUIFlags: $state => $state.uiFlags,
};

export const actions = {
  get: async ({ commit }, { page = 1, q = '' } = {}) => {
    commit(types.SET_WGPT_TASK_EXECUTIONS_UI_FLAG, { isFetching: true });
    try {
      const params = { page };
      if (q) params.q = q;
      const response = await new WgptExecutionsAPI().get(params);
      commit(types.SET_WGPT_TASK_EXECUTIONS_META, response.data.meta);
      commit(types.SET_WGPT_TASK_EXECUTIONS, response.data.payload);
    } catch (error) {
      throwErrorMessage(error);
    } finally {
      commit(types.SET_WGPT_TASK_EXECUTIONS_UI_FLAG, { isFetching: false });
    }
  },
  cancel: async ({ commit, state: $state }, id) => {
    try {
      await new WgptExecutionsAPI().cancel(id);
      const updated = $state.records.map(r =>
        r.id === id ? { ...r, status: 'cancelled' } : r
      );
      commit(types.SET_WGPT_TASK_EXECUTIONS, updated);
    } catch (error) {
      throwErrorMessage(error);
    }
  },
  runNow: async ({ commit, state: $state }, id) => {
    try {
      await new WgptExecutionsAPI().runNow(id);
      const updated = $state.records.map(r =>
        r.id === id ? { ...r, status: 'scheduled' } : r
      );
      commit(types.SET_WGPT_TASK_EXECUTIONS, updated);
    } catch (error) {
      throwErrorMessage(error);
    }
  },
  clear: ({ commit }) => {
    commit(types.SET_WGPT_TASK_EXECUTIONS, []);
    commit(types.SET_WGPT_TASK_EXECUTIONS_META, {});
  },
};

export const mutations = {
  [types.SET_WGPT_TASK_EXECUTIONS_UI_FLAG]($state, data) {
    $state.uiFlags = {
      ...$state.uiFlags,
      ...data,
    };
  },
  [types.SET_WGPT_TASK_EXECUTIONS_META]($state, data) {
    $state.meta = data;
  },
  [types.SET_WGPT_TASK_EXECUTIONS]($state, data) {
    $state.records = data;
  },
};

export default {
  namespaced: true,
  actions,
  state,
  getters,
  mutations,
};
